// extracted by mini-css-extract-plugin
export var logo = "_lq-2";
export var logoWrapper = "_lq-1";
export var strip = "_lq-0";